export default "__VITE_ASSET__msb1oDlL__"